import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  ContentSection,
  InstructionStepper,
  Layout,
  PageWrap,
  Paragraph,
  SectionHeading,
} from '@vwfs-bronson/bronson-react';
import { startIdentProcess } from '../../services/api/ident/startIdent';
import { storage } from '../../services/localStorage';
import { useNavigate } from '../../services/routing/navigate';
import { ApplicantType } from '../../types/identLandingPage';

interface Props {
  formData?: any;
  isCoApplicant?: boolean;
}

export const IdentLandingPage: FunctionComponent<Props> = (props) => {
  const { t } = useTranslation();
  const { isCoApplicant } = props;
  const navigate = useNavigate();

  const openScriveLink = () => {
    // Reset Onfido dashboard flow stale URL (if user abbandoned Onfido on Dashboard flow)
    delete storage.dashboardOnfidoFlow.postOnfidoDashboardRedirect;

    startIdentProcess(isCoApplicant ? ApplicantType.COAPPLICANT : ApplicantType.APPLICANT)
      .then((res) => {
        window.open(res.redirectUrl, '_self', 'rel=noopener noreferrer');
      })
      .catch(() => {
        navigate.error();
      });
  };

  return (
    <>
      <PageWrap>
        <ContentSection>
          <SectionHeading level={3}>{t('identLandingPage:title')}</SectionHeading>
          <Layout center>
            <Layout.Item>
              <Paragraph>{t('identLandingPage:subtitle')}</Paragraph>
            </Layout.Item>
          </Layout>
        </ContentSection>
        <ContentSection>
          <InstructionStepper
            statusActiveText={t('app:instructionStepper:activeLabel')}
            statusNotActiveText={t('app:instructionStepper:nonActiveLabel')}
          >
            <InstructionStepper.Step
              icon="document"
              title={t('identLandingPage:instructions:upload')}
              state="is-active"
            />
            <InstructionStepper.Step icon="checkmark" title={t('identLandingPage:instructions:analysis')} />
            <InstructionStepper.Step icon="pen" title={t('identLandingPage:instructions:sign')} />
            <InstructionStepper.Step icon="semantic-calendar" title={t('identLandingPage:instructions:vehicle')} />
          </InstructionStepper>
        </ContentSection>
        <ContentSection>
          <Layout center>
            <Layout.Item default="1/3">
              <Button
                type="button"
                full
                secondary
                onClick={() => {
                  navigate.creditCheckSuccess();
                }}
              >
                {t('identLandingPage:back')}
              </Button>
            </Layout.Item>
            <Layout.Item default="1/3">
              <Button type="button" full onClick={() => openScriveLink()}>
                {t('identLandingPage:next')}
              </Button>
            </Layout.Item>
          </Layout>
        </ContentSection>
      </PageWrap>
    </>
  );
};
